import React, { useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';

const ManagementApproval = () => {
    document.title = "Dashboard | Procurement Dashboard";
    const top100Films = [
        { label: 'The Shawshank Redemption', year: 1994 },
        { label: 'The Godfather', year: 1972 },
        { label: 'The Godfather: Part II', year: 1974 },
        { label: 'The Dark Knight', year: 2008 },
        { label: '12 Angry Men', year: 1957 },]
    const [showList, setShowList] = useState(false);

    const toggleList = () => {
        setShowList(!showList);
    };
    const [rows, setRows] = useState([
        {
            productName: '',
            quantity: '',
            value: ''
        }
    ])

    const columns = [
        { field: 'Sl_No',  headerName: (<div><Checkbox /><span>SL.No</span></div>), 
        width: 100,
        resizable: false,
        sortable: false,
        renderCell: (params) => {
            return <div><Checkbox /><span>1</span></div>;
        },
        },
        {
          field: 'Requisition_No',
          headerName: 'Requisition No',
          headerClassName: 'break-header',
        //   width: 160,
          editable: false,
          flex: 1,
          resizable: false,
        },
        {
          field: 'Requisition_Date',
          headerName: 'Requisition Date',
          headerClassName: 'break-header',
          flex: 1,
        //   width: 160,
          editable: false,
          resizable: false,
        },
        {
          field: 'Product_Name',
          headerName: 'Product Name',
          headerClassName: 'break-header',
          cellClassName: 'product_name_wrap',
          width: 160,
          editable: false,
          resizable: false,
          renderCell: (params) => {
            const productName = params.value;
            return (
              <div style={{cursor:'pointer'}}>
                {productName}
              </div>
            );
          },
        },
        {
          field: 'Total_Qty',
          headerName: 'Total Quantity',
          sortable: false,
          resizable: false,
          headerAlign: 'center',
          cellClassName: 'center-aligndata',
          headerClassName: 'break-header',
          flex: 1,
        //   width: 160,
        },
        {
          field: 'approved',
          headerName: 'Approved',
          headerClassName: 'table-header-background',
          sortable: false,
          resizable: false,
          headerAlign: 'center',
          cellClassName: 'center-aligndata',
          flex: 1,
        //   width: 160,
        },
        {
          field: 'remaining',
          headerName: 'Remaining',
          headerClassName: 'table-header-background',
          sortable: false,
          resizable: false,
          headerAlign: 'center',
          cellClassName: 'center-aligndata',
          flex: 1,
        //   width: 160,
        },
          {
            field: 'Allocation_QTY',
            headerName: 'Allocation (QTY)',
            headerClassName: 'break-header',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,
          },
          {
            field: 'Arrival_Date',
            headerName: 'Arrival Date',
            headerClassName: 'break-header',
            sortable: false,
            resizable: false,
            flex: 1,
            // width: 160,
          },
          {
            field: 'Value',
            headerName: 'Value',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,
          },
          {
            field: 'Status',
            headerName: 'Status',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            width: 160,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            renderCell: (params) => {
                const status = params.value;
                // Define the color for the chip based on the status
                let chipColor = 'default';
                if (status == 'Waiting for response') {
                  chipColor = 'error'; // Red color for waiting for response
                } else if (status == 'approved') {
                  chipColor = 'success'; // Green color for approved
                }
          
                // Render the Chip component with the outlined variant and appropriate color
                return <Chip className="status_badge" label={status} variant="outlined" color={chipColor} />;
              },
          },
      ];
      
      const approvalrows = [
        { id: 1, Sl_No: 1, Requisition_No: 'REQ1', Requisition_Date: '-', Product_Name: 'HOBS HB-MARICA', Total_Qty: 2,approved: 200, remaining: 0, Allocation_QTY: 10, Arrival_Date: '-', Value: 5, Status: 'Waiting for response' },
        { id: 2, Sl_No: 1, Requisition_No: 'REQ2', Requisition_Date: '-', Product_Name: 'HOBS HB-MARICA', Total_Qty: 2,approved: 200, remaining: 0, Allocation_QTY: 10, Arrival_Date: '-',Value: 5, Status: 'approved' },
      ];

    return (
        <React.Fragment>
         <div className="page-content">
            <Container fluid>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop:'10px' }}>
                        <div style={{ fontSize: '20px', }}>
                            <h4 className="mb-0 requisition_text">Management Approved</h4>
                        </div>
                        <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center">
                            <div><button onClick={toggleList} variant="outlined" className="filter_button"><span className="me-2"><TuneIcon /></span>Filter</button></div>
                            <div className="ms-2"><button className="save_button">Submit</button></div>
                        </div>
                        </div>
                    </div>
                    {showList && (

                        <div className="mt-3" style={{ display: 'flex', gap: '10px', alignItems: 'center',flexWrap:'wrap' }}>
                            <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={top100Films}
                                    sx={{ width: 200 }}
                                    renderInput={(params) => <TextField {...params} label="Search Product Name" />}
                                />
                            </div>
                            <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={top100Films}
                                    sx={{
                                        width: 170
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Requisition Number" />}
                                />
                            </div>
                            <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={top100Films}
                                    sx={{
                                        width: 120
                                    }}
                                    renderInput={(params) => <TextField {...params} label="RSM" />}
                                />
                            </div>
                            <div className="d-flex">
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker className='date_picker'
                                            label="From Date"
                                        // value={selectedDate}
                                        // onChange={handleDateChange}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div className="ms-2">
                                    <LocalizationProvider className='date_picker' dateAdapter={AdapterDayjs}>
                                        <DatePicker className='date_picker'
                                            label="To Date"
                                        // value={selectedEndDate}
                                        // onChange={handleEndDateChange}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </div>
                            <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={top100Films}
                                    sx={{ width: 120 }}
                                    renderInput={(params) => <TextField {...params} label="Status" />}

                                />
                            </div>
                            <div>
                                <Button className="me-2" variant="outlined">Search</Button>
                                <ReplayIcon />
                            </div>

                        </div>
                    )}

                    <Box sx={{ height: 400, width: '100%', marginBottom: '10px', marginTop:'10px' }}>
                        <DataGrid
                            className="table_header_background"
                            headerClassName="custom-header-cell"
                            rows={approvalrows}
                            columns={columns}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 5,
                                    },
                                },
                            }}
                            pageSizeOptions={[5]}
                            disableRowSelectionOnClick
                            disableColumnMenu 
                            componentsProps={{
                              cell: {
                                disableClick: true,
                              },
                            }}
                            sx={{
                              '& .MuiDataGrid-cell': {
                                '& .MuiDataGrid-cell--textOverflow': {
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                },
                              },
                            }}
                        />
                    </Box>
                </div>
            </Container>
            </div>
        </React.Fragment>
    );
};

export default ManagementApproval;
